(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  if(matchMedia("(pointer:fine)").matches&&!matchMedia("(prefers-reduced-motion:reduce)").matches){
    document.querySelectorAll("[data-dock]").forEach(container=>{
      const items=[...container.querySelectorAll(".category-tile")];
      container.addEventListener("pointermove",event=>{
        items.forEach(item=>{
          const rect=item.getBoundingClientRect();
          const distance=Math.abs(event.clientX-(rect.left+rect.width/2));
          const influence=Math.pow(Math.max(0,1-distance/330),1.5);
          item.style.scale=String(1+.14*influence);
          item.style.translate=`0 ${-16*influence}px`;
          item.style.zIndex=String(Math.round(influence*10)+1);
        });
      });
      container.addEventListener("pointerleave",()=>items.forEach(item=>{item.style.scale="1";item.style.translate="0 0";item.style.zIndex=""}));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const themeToggle=document.querySelector("[data-theme-toggle]");
  const menuToggle=document.querySelector(".menu-toggle");
  const mobileMenu=document.querySelector("#MobileMenu");
  const siteHeader=document.querySelector("[data-site-header]");
  const themeStorageKey="coffea-color-theme";
  const compactHeader=matchMedia("(max-width:420px)");
  const headerActions=document.querySelector(".header-actions");
  const headerUtilities=document.querySelector("[data-mobile-header-utilities]");
  const syncHeaderUtilities=()=>{
    if(!themeToggle||!headerUtilities||!headerActions)return;
    if(compactHeader.matches)headerUtilities.append(themeToggle);
    else headerActions.insertBefore(themeToggle,headerActions.querySelector(".cart-pill"));
  };
  syncHeaderUtilities();
  compactHeader.addEventListener("change",syncHeaderUtilities);

  const syncThemeToggle=()=>{
    if(!themeToggle)return;
    const darkTheme=document.documentElement.dataset.colorTheme==="dark";
    const nextLabel=darkTheme?themeToggle.dataset.lightLabel:themeToggle.dataset.darkLabel;
    themeToggle.setAttribute("aria-pressed",String(darkTheme));
    themeToggle.setAttribute("aria-label",nextLabel);
    themeToggle.title=nextLabel;
  };
  const applyColorTheme=colorTheme=>{
    document.documentElement.dataset.colorTheme=colorTheme;
    const themeColor=document.querySelector('meta[name="theme-color"]');
    if(themeColor)themeColor.content=getComputedStyle(document.documentElement).getPropertyValue("--paper").trim();
    syncThemeToggle();
  };
  syncThemeToggle();
  if(themeToggle){
    themeToggle.addEventListener("click",()=>{
      const nextTheme=document.documentElement.dataset.colorTheme==="dark"?"light":"dark";
      const updateTheme=()=>applyColorTheme(nextTheme);
      if(document.startViewTransition&&!matchMedia("(prefers-reduced-motion: reduce)").matches){
        document.startViewTransition(updateTheme);
      }else{
        updateTheme();
      }
      try{
        localStorage.setItem(themeStorageKey,nextTheme);
      }catch(error){}
    });
  }
  const syncStickyHeader=()=>{
    if(!siteHeader)return;
    const isScrolled=siteHeader.classList.contains("is-scrolled");
    if(!isScrolled&&scrollY>96)siteHeader.classList.add("is-scrolled");
    else if(isScrolled&&scrollY<8)siteHeader.classList.remove("is-scrolled");
  };
  syncStickyHeader();
  addEventListener("scroll",syncStickyHeader,{passive:true});
  if(menuToggle&&mobileMenu){
    menuToggle.addEventListener("click",()=>{
      const open=menuToggle.getAttribute("aria-expanded")==="true";
      menuToggle.setAttribute("aria-expanded",String(!open));
      mobileMenu.hidden=open;
      document.body.classList.toggle("mobile-menu-open",!open);
    });
    mobileMenu.addEventListener("click",event=>{
      if(event.target.closest("a")){
        menuToggle.setAttribute("aria-expanded","false");
        mobileMenu.hidden=true;
        document.body.classList.remove("mobile-menu-open");
      }
    });
    document.addEventListener("keydown",event=>{
      if(event.key==="Escape"&&menuToggle.getAttribute("aria-expanded")==="true"){
        menuToggle.click();
        menuToggle.focus();
      }
    });
    document.addEventListener("click",event=>{
      if(menuToggle.getAttribute("aria-expanded")==="true"&&!event.target.closest("[data-site-header]"))menuToggle.click();
    });
    addEventListener("resize",()=>{
      if(innerWidth>1200&&menuToggle.getAttribute("aria-expanded")==="true")menuToggle.click();
    });
  }
  const cubeNamespace="http://www.w3.org/2000/svg";
  const syncCubeFace=target=>{
    let svg=target.querySelector(":scope > .cube-face-svg");
    if(svg&&!svg.querySelector("[data-cube-outline]")){
      svg.remove();
      svg=null;
    }
    if(!svg){
      svg=document.createElementNS(cubeNamespace,"svg");
      svg.classList.add("cube-face-svg");
      svg.setAttribute("aria-hidden","true");
      svg.setAttribute("focusable","false");
      svg.setAttribute("preserveAspectRatio","none");
      const top=document.createElementNS(cubeNamespace,"polygon");
      top.dataset.cubePlane="top";
      const side=document.createElementNS(cubeNamespace,"polygon");
      side.dataset.cubePlane="side";
      const outline=document.createElementNS(cubeNamespace,"path");
      outline.dataset.cubeOutline="";
      svg.append(top,side,outline);
      target.prepend(svg);
    }
    const width=target.offsetWidth;
    const height=target.offsetHeight;
    const depth=parseFloat(getComputedStyle(target).getPropertyValue("--cube-depth"))||7;
    svg.setAttribute("viewBox",`0 0 ${width+depth} ${height+depth}`);
    svg.querySelector('[data-cube-plane="top"]').setAttribute("points",`0,${depth} ${depth},0 ${width+depth},0 ${width},${depth}`);
    svg.querySelector('[data-cube-plane="side"]').setAttribute("points",`${width},${depth} ${width+depth},0 ${width+depth},${height} ${width},${height+depth}`);
    svg.querySelector("[data-cube-outline]").setAttribute("d",`M 0 ${depth} L ${depth} 0 L ${width+depth} 0 L ${width+depth} ${height} L ${width} ${height+depth} L 0 ${height+depth} Z M 0 ${depth} L ${width} ${depth} L ${width} ${height+depth} M ${width} ${depth} L ${width+depth} 0`);
  };
  const cubeObserver=new ResizeObserver(entries=>entries.forEach(entry=>syncCubeFace(entry.target)));
  const initCubeFaces=(root=document)=>{
    root.querySelectorAll(".button,.theme-toggle,.cart-pill,.menu-toggle").forEach(target=>{
      syncCubeFace(target);
      cubeObserver.observe(target);
    });
  };
  initCubeFaces();
  document.addEventListener("shopify:section:load",event=>initCubeFaces(event.target));
  const reduceMotion=matchMedia("(prefers-reduced-motion: reduce)").matches;
  const revealTargets=document.querySelectorAll(".product-card,.category-tile,.section-heading,.motion-reveal");
  if(reduceMotion){
    revealTargets.forEach(target=>target.classList.add("is-in-view"));
  }else{
    const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add("is-in-view");
        revealObserver.unobserve(entry.target);
      }
    }),{threshold:.08,rootMargin:"0px 0px -30px"});
    revealTargets.forEach(target=>{
      target.classList.add("soft-reveal");
      revealObserver.observe(target);
    });
  }
  if(!reduceMotion&&matchMedia("(pointer:fine)").matches){
    document.querySelectorAll("[data-pointer-field]").forEach(field=>{
      field.addEventListener("pointermove",event=>{
        const rect=field.getBoundingClientRect();
        const x=(event.clientX-rect.left)/rect.width-.5;
        const y=(event.clientY-rect.top)/rect.height-.5;
        field.style.setProperty("--motion-x",`${x*10}px`);
        field.style.setProperty("--motion-y",`${y*10}px`);
        field.style.setProperty("--motion-rx",`${y*-4}deg`);
        field.style.setProperty("--motion-ry",`${x*5}deg`);
      });
      field.addEventListener("pointerleave",()=>{
        field.style.setProperty("--motion-x","0px");
        field.style.setProperty("--motion-y","0px");
        field.style.setProperty("--motion-rx","0deg");
        field.style.setProperty("--motion-ry","0deg");
      });
    });
  }
  document.addEventListener("submit",async event=>{
    const form=event.target.closest("[data-quick-add-form]");
    if(!form||window.coffeaCartReady)return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    const toast=document.querySelector(".coffea-toast");
    if(!button||button.disabled)return;
    button.disabled=true;
    button.setAttribute("aria-busy","true");
    try{
      const response=await fetch(form.action,{
        method:"POST",
        body:new FormData(form),
        headers:{"Accept":"application/json"}
      });
      if(!response.ok)throw new Error("cart-add-failed");
      const root=window.Shopify?.routes?.root||"/";
      const cartResponse=await fetch(`${root}cart.js`,{headers:{"Accept":"application/json"}});
      if(!cartResponse.ok)throw new Error("cart-refresh-failed");
      const cart=await cartResponse.json();
      document.querySelectorAll(".cart-pill strong").forEach(count=>count.textContent=cart.item_count);
      if(toast){
        toast.textContent=form.dataset.successMessage;
        toast.classList.add("show");
        clearTimeout(window.coffeaToastTimer);
        window.coffeaToastTimer=setTimeout(()=>toast.classList.remove("show"),2400);
      }
    }catch(error){
      if(toast){
        toast.textContent=form.dataset.errorMessage;
        toast.classList.add("show");
        clearTimeout(window.coffeaToastTimer);
        window.coffeaToastTimer=setTimeout(()=>toast.classList.remove("show"),3200);
      }
    }finally{
      button.disabled=false;
      button.removeAttribute("aria-busy");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const cubeNamespace="http://www.w3.org/2000/svg";
  const syncCubeFace=target=>{
    let svg=target.querySelector(":scope > .cube-face-svg");
    if(svg&&!svg.querySelector("[data-cube-outline]")){
      svg.remove();
      svg=null;
    }
    if(!svg){
      svg=document.createElementNS(cubeNamespace,"svg");
      svg.classList.add("cube-face-svg");
      svg.setAttribute("aria-hidden","true");
      svg.setAttribute("focusable","false");
      svg.setAttribute("preserveAspectRatio","none");
      const top=document.createElementNS(cubeNamespace,"polygon");
      top.dataset.cubePlane="top";
      const side=document.createElementNS(cubeNamespace,"polygon");
      side.dataset.cubePlane="side";
      const outline=document.createElementNS(cubeNamespace,"path");
      outline.dataset.cubeOutline="";
      svg.append(top,side,outline);
      target.prepend(svg);
    }
    const width=target.offsetWidth;
    const height=target.offsetHeight;
    const depth=parseFloat(getComputedStyle(target).getPropertyValue("--cube-depth"))||9;
    svg.setAttribute("viewBox",`0 0 ${width+depth} ${height+depth}`);
    svg.querySelector('[data-cube-plane="top"]').setAttribute("points",`0,${depth} ${depth},0 ${width+depth},0 ${width},${depth}`);
    svg.querySelector('[data-cube-plane="side"]').setAttribute("points",`${width},${depth} ${width+depth},0 ${width+depth},${height} ${width},${height+depth}`);
    svg.querySelector("[data-cube-outline]").setAttribute("d",`M 0 ${depth} L ${depth} 0 L ${width+depth} 0 L ${width+depth} ${height} L ${width} ${height+depth} L 0 ${height+depth} Z M 0 ${depth} L ${width} ${depth} L ${width} ${height+depth} M ${width} ${depth} L ${width+depth} 0`);
  };
  const cubeObserver=new ResizeObserver(entries=>entries.forEach(entry=>syncCubeFace(entry.target)));
  document.querySelectorAll(".password-field button,.password-login button").forEach(target=>{
    syncCubeFace(target);
    cubeObserver.observe(target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".faq-list details").forEach(detail=>detail.addEventListener("toggle",()=>{
    if(detail.open)document.querySelectorAll(".faq-list details").forEach(other=>{if(other!==detail)other.open=false});
  }));

  } catch(e) { console.error(e); }
})();
})();
